var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var Logger = /** @class */ (function () {
    function Logger(label, enabled) {
        var _this = this;
        this.log = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (!_this.enabled) {
                return;
            }
            console.log.apply(console, __spreadArray(["[".concat(_this.label, "]")], args, false));
        };
        this.label = label;
        this.enabled = enabled;
    }
    Logger.get = function (label, enabled) {
        if (enabled === void 0) { enabled = true; }
        if (!Logger.instances[label]) {
            Logger.instances[label] = new Logger(label, enabled);
        }
        return Logger.instances[label];
    };
    Logger.instances = {};
    return Logger;
}());
export { Logger };
